<template>
<div class="sidebar-menu">
  <!-- Building Select -->
  <div class="building-select">
    <ul class="nav-tabs">
      <li class="tab">
        <a class="tab-link" :class="{ active: isActiveBuilding('tower') }" @click.prevent="selectBuilding('tower')" aria-current="page" href="#">Tower Homes</a>
      </li>
      <li class="tab">
        <a class="tab-link" :class="{ active: isActiveBuilding('terrace') }" @click.prevent="selectBuilding('terrace')" href="#">Terrace Homes</a>
      </li>
    </ul>
  </div>

  <div class="sidebar-main">
    <!-- Level Selet -->
    <div class="level-select">
      <h2>Levels</h2>
      <ul class="button-list">
        <li v-for="(floorGroup, index) in floorGroupsInActiveBuilding" :key="index">
          <button v-html="floorGroup.label" :class="{ active: isActiveFloorGroup(floorGroup.slug) }" @click="selectFloorGroup(floorGroup.slug)"></button>
        </li>
      </ul>
    </div>

    <!-- Bedroom Filter -->
    <div class="bedrooms-filter">
      <h2>Bedrooms</h2>
      <ul class="button-list">
        <li v-for="(bedroomOption, index) in bedroomOptionsInFloorGroup" :key="index">
          <button v-html="bedroomOption[0]" :class="{ active: bedroomOption === activeBedroomOption }" @click="applyBedroomFilter(bedroomOption)"></button>
        </li>
      </ul>
    </div>

    <!-- Reset Filters -->
    <a class="reset-filters" href="#" @click.prevent="$emit('reset-filters')">Reset filters</a>

    <!-- Key Plate -->
    <key-plate
      :active-building="activeBuilding"
      :active-floor-group="activeFloorGroup"
      :active-unit="activeUnit"
      :active-bedroom-option="activeBedroomOption"
      :bedroom-options="floorGroupBedroomOptions"
      @select-unit="onSelectUnit"
    ></key-plate>

    <div class="sidebar-bottom">
      <!-- North Indicator -->
      <svg class="north-indicator" width="15" height="35" viewBox="0 0 15 35">
        <path d="M7.75163 0.937988L12.4183 14.938L7.75163 11.911L3.08496 14.938L7.75163 0.937988Z" fill="#7C6663"/>
        <path d="M14.7515 20.8108C13.7644 21.2663 13.2407 22.1574 13.2407 23.6425V34.7712H12.9385L2.84643 22.2564V31.7019C2.84643 33.2465 3.37017 34.1574 4.39751 34.593V34.6326H0.751465V34.593C1.73852 34.1376 2.26226 33.2465 2.26226 31.7613V23.2663C2.26226 21.9594 2.06082 21.2663 1.11405 20.8108V20.7712H4.78024L12.6565 30.6326V23.7019C12.6565 22.1574 12.1328 21.2465 11.0853 20.8108V20.7712H14.7515V20.8108Z" fill="#7C6663"/>
      </svg>
    </div>
  </div>
</div>
</template>

<script>
import KeyPlate from './KeyPlate.vue'

export default {
  props: [
    'active-building',
    'active-floor-group',
    'active-unit',
    'active-bedroom-option',
    'bedroom-options-in-floor-group'
  ],
  components: { KeyPlate },
  data() {
    return {
      plans: floorplanData.plans,
      towerFloorGroups: floorplanData.tower_floor_groups,
      terraceFloorGroups: floorplanData.terrace_floor_groups,
    }
  },
  methods: {
    isActiveBuilding(building) {
      return building === this.activeBuilding
    },
    isActiveFloorGroup(floorGroupSlug) {
      return floorGroupSlug == this.activeFloorGroup
    },
    selectBuilding(building) {
      this.$emit('select-building', building)
    },
    selectFloorGroup(floorGroupSlug) {
      this.$emit('select-floor-group', floorGroupSlug)
    },
    onSelectUnit(unitNumber) {
      this.$emit('select-unit', unitNumber)
    },
    applyBedroomFilter(bedroomOption) {
      this.$emit('apply-bedroom-filter', bedroomOption)
    }
  },
  computed: {
    floorGroupsInActiveBuilding() {
      let floorGroupArray = []

      if (this.activeBuilding === 'tower') floorGroupArray = this.towerFloorGroups
      else floorGroupArray = this.terraceFloorGroups

      floorGroupArray = floorGroupArray.filter((floorGroup) => { return floorGroup.units.length })

      return floorGroupArray
    },
    // Array of all bedroom filter options for the active floor group
    floorGroupBedroomOptions() {
      let activeFloorGroupData = this[this.activeBuilding + 'FloorGroups'].find((floorGroup) => { return floorGroup.slug === this.activeFloorGroup })
      let unitsInActiveFloorGroup = activeFloorGroupData.units

      let floorGroupBedroomOptions = unitsInActiveFloorGroup.map((unit) => { 
        let planData = this.plans.find((plan) => { return plan.id === unit.plan_id })

        return planData.plan_type.value.split('_')[0]
      })
      
      return floorGroupBedroomOptions
    }
  }
}
</script>